const address = {
  'address.title': '地址管理',
  'address.address': '收货地址',
  'address.address.placeholder': '请选择收货地址',
  'address.add': '新增',
  'address.addAddress': '新增地址',
  'address.edit': '编辑',
  'address.editAddress': '编辑地址',
  'address.delete': '删除',
  'address.deleteAddress': '删除地址',
  'address.default': '默认',
  'address.defaultAddress': '默认地址',
  'address.setDefault': '设为默认',
  'address.setDefaultAddress': '设为默认地址',
  'address.switch': '切换',
  'address.switchAddress': '切换地址',

  'address.country': '国家',
  'address.country.placeholder': '请输入国家',
  'address.country.maxLength': '国家名称不能超过{total}个字符',
  'address.state': '州/省',
  'address.state.placeholder': '请输入州/省',
  'address.state.maxLength': '州/省名称不能超过{total}个字符',
  'address.city': '城市',
  'address.city.placeholder': '请输入城市',
  'address.city.maxLength': '城市名称不能超过{total}个字符',
  'address.street': '街道',
  'address.street.placeholder': '请输入街道',
  'address.street.maxLength': '街道名称不能超过{total}个字符',
  'address.detail': '详细地址',
  'address.detail.placeholder': '请输入详细地址',
  'address.detail.maxLength': '详细地址不能超过{total}个字符',

  'address.recipient_name': '收件人',
  'address.recipient_name.placeholder': '请输入收件人姓名',
  'address.recipient_name.maxLength': '收件人名称不能超过{total}个字符',
  'address.recipient_name.minLength': '收件人名称不能少于{total}个字符',
  'address.recipient_name.pattern': '收件人名称只能包含中文、英文字母和空格',

  'address.phone': '联系电话',
  'address.phone.placeholder': '请输入联系电话，例：+86 13800138000',
  'address.phone.maxLength': '联系电话不能超过{total}个字符',
  'address.phone.pattern': '请输入有效的电话号码，需包含国家区号',

  'address.postal_code': '邮政编码',
  'address.postal_code.placeholder': '请输入邮政编码',
  'address.postal_code.maxLength': '邮政编码不能超过{total}个字符',
  'address.postal_code.pattern': '请输入有效的邮政编码',

  'address.updateSuccess': '地址更新成功',
  'address.createSuccess': '地址添加成功',
  'address.deleteSuccess': '地址删除成功',
  'address.setDefaultSuccess': '设置默认地址成功',

  'address.confirmDelete': '确认删除此地址？',
};

export default address;
